import { Button, Card, Col, Form, Input, message, Popconfirm, Row, Table, Typography } from 'antd';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addRelationShip, deleteRelationShip, getAllRelationShip, updateRelationShip } from '../../redux/rtk/features/masters/relationShipSlice';
import PageTitle from '../page-header/PageHeader';

const RelationshipMaster = () => {
  const { Title } = Typography;

  const [editingRelationShip, setEditingRelationShip] = useState(null);
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { list, loading } = useSelector((state) => state.relationShip);

  useEffect(() => {
    dispatch(getAllRelationShip());
  }, [dispatch]);


  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      if (editingRelationShip) {
        // Update existing relationShip
        const result = await dispatch(
          updateRelationShip({ id: editingRelationShip.id, values })
        ).unwrap();
        if (result.message === 'success') {
          dispatch(getAllRelationShip());
        } else {
          message.error('Error updating relationShip!');
        }
      } else {
        // Add new relationShip
        const result = await dispatch(addRelationShip(values)).unwrap();
        if (result.message === 'success') {
          dispatch(getAllRelationShip());
        } else {
          message.error('Error adding relationShip!');
        }
      }
      setEditingRelationShip(null);
    } catch (error) {
      console.error('Validation failed or API error:', error);
      // message.error('Failed to add or update relationShip!');
    }
  };

  // Handle deletion
  const handleDelete = async (id) => {
    try {
      const result = await dispatch(deleteRelationShip(id)).unwrap();
      if (result?.message === 'success') {
        dispatch(getAllRelationShip()); // Refresh table data
      } else {
      }
    } catch (error) {
      console.error('Delete API error:', error);
    }
  };

  // Table columns
  const columns = [
    {
      title: 'Relationship',
      dataIndex: 'relationship',
      key: 'relationship',
    },

    {
      title: 'Actions',
      key: 'actions',
      render: (_, record) => (
        <>
          <Button type="link" onClick={() => {setEditingRelationShip(record); form.setFieldsValue(record)}}>
            Edit
          </Button>
          <Popconfirm
            title="Are you sure you want to delete this relationship?"
            onConfirm={() => handleDelete(record.id)}
            okText="Yes"
            cancelText="No"
          >
            <Button type="link" danger>
              Delete
            </Button>
          </Popconfirm>
        </>
      ),
    },
  ];

  return (
    <div>
      <PageTitle title='Back' />
      <Row gutter={16}>
        <Col span={8}>
          <Card title={editingRelationShip ? 'Edit Relationship' : 'Add Relationship'}>
            <Form
              form={form}
              style={{ marginBottom: "40px" }}
              name="relationShip-form"
              labelCol={{ span: 8 }}
              wrapperCol={{ span: 14 }}
              onFinish={handleOk}
              autoComplete="off"
            >
      
          <Form.Item
            name="relationship"
            label="Relationship"
            rules={[{ required: true, message: 'Please enter a relationShip!' }]}
          >
            <Input placeholder="Enter relationShip " />
          </Form.Item>

          <Button type="primary" block htmlType="submit">
                {editingRelationShip ? 'Update Relationship' : 'Add Relationship'}
              </Button>
            </Form>
          </Card>
        </Col>
        <Col span={16}>
          <Card title="Relationship List">
            <Table
              dataSource={list}
              columns={columns}
              rowKey="id"
              loading={loading}
              style={{ marginTop: 0 }}
            />
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default RelationshipMaster;
